import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { SidebarService } from './sidenav.service';
import { SideBarData } from 'src/app/settings/nav-list/recursive-sidebar/class/sidebar';
import { SideNavButtonComponent } from './option-button/button.component';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  templateUrl: './sidenav.component.html',
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    NgScrollbarModule,
    RouterOutlet,
    MatExpansionModule,
    MatListModule,
    ToolbarComponent,
    SideNavButtonComponent,
  ],
  styleUrls: ['./sidenav.component.sass'],
})
export class SidenavComponent implements OnInit, OnDestroy {
  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private authService: AuthService,
    private sidenavService: SidebarService
  ) {}
  // Datos fijos
  sidebar = this.sidenavService.sidebar;
  subscriptions: Subscription[] = [];
  // Inicializar el sidemenu y crear las suscrpiciones
  ngOnInit(): void {
    this.setUpObservables();
    this.onChangeForLink();
    this.getAllowedSideNavItems();
    this.restructureDepartmentsGroup();
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  setUpObservables(): void {
    let sub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.onChangeForLink();
      });
    this.subscriptions.push(sub);

    sub = this.layoutService.sideNavMode$.subscribe((mode) => {
      this.sidebar.SideNavMode = mode;
    });
    this.subscriptions.push(sub);
    sub = this.layoutService.sideNavOpen$.subscribe((open) => {
      this.sidebar.SideNavOpen = open;
    });
    this.subscriptions.push(sub);
    sub = this.sidenavService.sidenavToggle$.subscribe(() => {
      this.selectedButton();
    });
    this.subscriptions.push(sub);
  }
  // Logica
  onChangeForLink(): void {
    this.sidenavService.cargarRutas(this.router.routerState.snapshot.url);
  }

  getAllowedSideNavItems(): void {
    const userRoles = this.authService.getUserRole();
    this.sidenavService.obtenerRutasPermitidas(userRoles);
  }
  restructureDepartmentsGroup(): void {
    this.sidenavService.reestructurarDepartamentos();
  }
  changeSideNavActive(sideBar: SideBarData): void {
    this.sidebar.ActiveSidebar = sideBar;
    this.sidebar.ButonsData = [...sideBar.data];
    this.getAllowedSideNavItems();
    this.restructureDepartmentsGroup();
  }
  closeSideNav(): void {
    this.layoutService.closeSideNav();
  }
  selectedButton(): void {
    if (this.sidebar.SideNavMode === 'over') {
      this.closeSideNav();
    }
  }
}
